// src/pages/Contact.jsx
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Contact = () => (
  <>
    <Header />
    <main style={styles.main}>
      <h1>Contact Us</h1>
      <p>
        Have questions, suggestions, or need help? We're here to assist you.
      </p>
      <div style={styles.contactBox}>
        <h3>Email</h3>
        <p>
          📧 <a href="mailto:info@currentjobs.co.ke">info@currentjobs.co.ke</a>
        </p>

        <h3>Phone</h3>
        <p>📞 Coming soon!</p>

        <h3>Response Time</h3>
        <p>We aim to respond within 24 hours on business days.</p>

        <h3>Privacy Notice</h3>
        <p>Your contact information will only be used to respond to your inquiry.</p>
      </div>
    </main>
    <Footer />
  </>
);

const styles = {
  main: {
    padding: '2rem',
    maxWidth: '800px',
    margin: 'auto',
    lineHeight: 1.6
  },
  contactBox: {
    backgroundColor: '#f9f9f9',
    padding: '1.5rem',
    borderRadius: '8px',
    boxShadow: '0 1px 5px rgba(0,0,0,0.1)',
    marginTop: '1rem'
  }
};

export default Contact;
